module.exports = __webpack_public_path__ + "img/img041.69c297b4.png";